import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import InsertLinkUI from './insertlinkui';


export default class InsertLink extends Plugin {
  static get pluginName() {
    return 'InsertLink';
  }

  static get requires() {
    return [ InsertLinkUI];
  }
}
